// removed by extract-text-webpack-plugin
module.exports = {"root":"_3r3Zhs9","heading":"_2GdiFiF","instructions":"_3uujfjq","instruction":"_25tg0JU","instructionImage":"_-mrvq0U","title":"_2RY3ezC","message":"_2aLp8VN","message_isRefine":"_1WwFBMh","gotIt":"_2OC2Xez","gotItLink":"_3evONpZ"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Onboard/Onboard.less
 ** module id = 748
 ** module chunks = 0
 **/